import { render, staticRenderFns } from "./ProductionParent.vue?vue&type=template&id=3e1add3e&scoped=true&"
import script from "./ProductionParent.vue?vue&type=script&lang=js&"
export * from "./ProductionParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1add3e",
  null
  
)

export default component.exports